import api from "../helpers/api";
import store from '@/state/store';

class ActionService{

      
    async create_action(data) {
        
        return await api.post(`/actions`,
           data,
        )
        .then((response) => {
            return response.data.data;
        });
    }

    async create_user_action(data) {
        
        return await api.post(`/create-user-action`,
           data,
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async get_actions(page, is_verified) {
        const user = store.getters['authfack/getCurrentUser']; // Get current user
        const asUserParam = user.user_type === 'admin' ? '' : '&as_user=true';
        const verifiedParam = is_verified !== undefined ? `&is_verified=${is_verified}` : ''; // Add the is_verified parameter
    
        return await api.get(`actions?page=${page}${asUserParam}${verifiedParam}`).then(
            response => {
                return response.data
            }
        )
    }
    async search_action(query) {
        try {
            const response = await api.get(`/action/search`, {
            params: { q: query },
            });
            return response.data;
        } catch (error) {
            console.error("Error searching action:", error);
            throw error;
        }
    }


    // import actions in an excel file 
    async import_actions(data){
        return await api.post(`import-actions`,data).then(
            response => {
                return response.data.data;
            }
        )
    }
    // export actions in an excel file 
    async export_actions(data){
        return await api.post(`actions/export`,data,{
            responseType: "blob", // Ensures the response is treated as a file
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exported_actions.csv"); // Adjust the filename as needed
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch((error) => {
          console.error("Export failed:", error);
          throw error; 
        });
    }

   
    async get_action(id){
        return await api.get(`actions/${id}`).then(
            response => {
                return response.data
            }
        )}


    async update_action(data, id){
        
        return await api.post(`actions/${id}`,data).then(
            response => {
                return response.data
            }
        )
    }
    async update_user_action(data, id){
        
        return await api.post(`update-user-action/${id}`,data).then(
            response => {
                return response.data
            }
        )
    }

    async rejectAction(actionId, rejectionMessage) {
        console.log(rejectionMessage);
        
        // try {
          const response = await api.post(`/actions/${actionId}/reject`, {
            rejection_message: rejectionMessage,
          });
          return response.data;
        // } catch (error) {
        //   throw new Error(error.response ? error.response.data.message : 'Request failed');
        // }
    }

    async delete_action(id){
        return await api.delete(`actions/${id}`).then(
            response => {
                return response.data
            }
        )}

    //image functions

    async getImages(id){
        return await api.get(`action/images/${id}`,{
           
        }).then(
            response => {
                return response.data
            }
        )
    }


    async uploadImages(formData,id) {
        return api.post(`action/${id}/store`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        });
    }

    async delete_image(imageId) {
        return api.delete(`/action-images/${imageId}`);
    }


    // Response functions 
    async add_responses(data) {
        
        return await api.post(`/responses`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async update_responses(data) {
        
        return await api.put(`/responses/${data.id}`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response.data.data;
        });
    }
    
    async get_responses(){
        return await api.get(`actions/response`).then(
            response => {
                return response.data
            }
        )
    }

    async delete_response(response_id) {
        return api.delete(`/responses/${response_id}`);
    }

    async action_type_distribution(yearParam){
        return await api.get(`charts/action-type-distribution/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }
    async actions_by_region(yearParam){
        return await api.get(`charts/actions-by-region/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }

    async actions_by_month(yearParam){
        return await api.get(`charts/actions-by-month/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }
    async actions_by_year(yearParam){
        return await api.get(`charts/actions-by-year/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }

    async action_response_distribution(yearParam){
        return await api.get(`charts/action-response-distribution/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }

    async monthly_action_response_distribution(yearParam){
        return await api.get(`charts/action-response-distribution-monthly/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }
    async yearly_action_response_distribution(yearParam){
        return await api.get(`charts/action-response-distribution-yearly/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }

    async action_intention_distribution(yearParam){
        return await api.get(`charts/action-intention-distribution/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }
    async monthly_action_intention_distribution(yearParam){
        return await api.get(`charts/action-intention-distribution-monthly/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }
    async yearly_action_intention_distribution(yearParam){
        return await api.get(`charts/action-intention-distribution-yearly/${yearParam}`).then(
            response => {
                return response.data;
            }
        )
    }

    async generate_action_report(yearParam){
        return await api.get(`action_report`,{yearParam}).then(
            response => {
                return response.data;
            }
        )
    }

}
export default new ActionService;